import { makeStyles } from "@mui/styles";
import { styled } from "@mui/system";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useContext, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import {
  useCreateAddresses,
  useDeleteAddresses,
  useGetAddresses,
  useGetCep,
  useUpdateAddresses,
} from "../../API/Hooks/Addresses";
import ContactMailSharpIcon from "@mui/icons-material/ContactMailSharp";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import BusinessIcon from "@mui/icons-material/Business";
import FormatListNumberedSharpIcon from "@mui/icons-material/FormatListNumberedSharp";
import FlagSharpIcon from "@mui/icons-material/FlagSharp";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import HolidayVillageSharpIcon from "@mui/icons-material/HolidayVillageSharp";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import InputBase from "@mui/material/InputBase";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import FaceIcon from "@mui/icons-material/Face";
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { modeContext } from "../../App";
import { UserContext } from "../../contexts/User";
import { CompanyContext } from "../../contexts/Company";

const useStyles = makeStyles({
  root: {
    minHeight: "440px",
    width: "85%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    margin: "50px 0 20px 0",
    backgroundColor: "#FFFFFF",
    padding: "0 30px 15px 30px",
    borderRadius: "15px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  },
  rootLoading: {
    opacity: "0",
  },
  rootEdit: {
    minHeight: "600px",
    width: "85%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "50px 0 20px 0",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    padding: "0 30px 0 30px",
    borderRadius: "15px",
  },
  rootDesktop: {
    minHeight: "440px",
    width: "40%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    margin: "70px 0 20px 0",
    backgroundColor: "#FFFFFF",
    padding: "0 30px 0 30px",
    borderRadius: "15px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  },
  rootDesktopEdit: {
    minHeight: "600px",
    width: "40%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "50px 0 20px 0",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    padding: "0 30px 0 30px",
    borderRadius: "15px",
  },
  rootDesktopEditDark: {
    minHeight: "600px",
    width: "40%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "50px 0 20px 0",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    padding: "0 30px 0 30px",
    borderRadius: "15px",
  },
  sessionTitle: {
    fontWeight: "bold",
    fontSize: "1.5em",
    color: "#050821",
    paddingBottom: "5px",
  },
  addressContainer: {
    width: "100%",
    minHeight: "130px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  addressTitle: {
    fontSize: "1.4em",
    lineHeight: "1.1em",
    fontWeight: "700",
  },
  addressInfo: {
    fontSize: "1.1em",
    fontWeight: "600",
    color: "#777373",
  },
  iconAndAddressContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "90%",
    minHeight: "130px",
    marginBottom: "15px",
  },
  sessionTitleContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    height: "70px",
    alignItems: "center",
  },
  inputsContainer: {
    height: "515px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
  },
  IconAndInputContainer: {
    display: "flex",
    alignItems: "center",
    position: "relative",
  },
  buttonsContainer: {
    width: "70%",
    minWidth: "300px",
    display: "flex",
    justifyContent: "space-around",
  },
  buttonsContainerMobile: {
    width: "50%",
    minWidth: "300px",
    display: "flex",
    justifyContent: "space-around",
  },
  select: {
    width: "200px",
    height: "50px",
    "& .MuiInputBase-input": {
      "&:focus": {
        borderStyle: "none",
        borderRadius: "10px",
      },
    },
    "& .MuiSelect-select": {
      padding: "10px",
    },
    "& .MuiSvgIcon-root": {
      margin: "0",
      position: "absolute",
      top: "7px",
    },
  },
  selectContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  editAndDeleteIconContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  inputsAndButtonsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
});

const authInputStyles = {
  backgroundColor: "white",
  textTransform: "unset",
  zIndex: "0",
  borderRadius: "10px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    minHeight: 48,
    backgroundColor: "#fff",
    "& fieldset": {
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "#C9C9C9",
    },
    "&:hover fieldset": {
      borderColor: "#9E9E9E",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#050821",
      borderWidth: "1px",
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "12px 14px !important",
    height: "24px !important",
    boxSizing: "content-box",
    fontSize: "1rem !important",
  },
  "& label.Mui-focused": {
    color: "#050821",
  },
};

const authInputStylesDark = {
  backgroundColor: "#474A56",
  textTransform: "unset",
  zIndex: "0",
  borderRadius: "10px",
  "& label.MuiInputLabel-root": {
    color: "white",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    minHeight: 48,
    color: "white",
    "& fieldset": {
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "white",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
      borderWidth: "1px",
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "12px 14px !important",
    height: "24px !important",
    boxSizing: "content-box",
    fontSize: "1rem !important",
  },
  "& label.Mui-focused": {
    color: "white",
  },
};

const authButtonStyles = {
  height: 48,
  backgroundColor: "#050821 !important",
  color: "#fff !important",
  textTransform: "none",
  fontWeight: 700,
  fontSize: "1.05rem",
  borderRadius: "10px",
  boxShadow: "none !important",
  border: "1px solid #050821",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: "#121531 !important",
    boxShadow: "none !important",
  },
};

const StyledEditIcon = styled(EditIcon, {
  name: "StyledButton",
})({
  margin: "0",
  height: "30px",
});

const StyledEditIconDark = styled(EditIcon, {
  name: "StyledButton",
})({
  color: "#474A56",
  margin: "0",
  height: "30px",
});

const StyledAddCircleSharpIcon = styled(AddCircleSharpIcon, {
  name: "StyledButton",
})({
  margin: "0 0 0 10px",
});

const StyledAddCircleSharpIconDark = styled(AddCircleSharpIcon, {
  name: "StyledButton",
})({
  color: "#474A56",
  margin: "0 0 0 10px",
});

const StyledTextFieldDesktop = styled(TextField, {
  name: "StyledTextField",
})({
  width: "30vw",
  ...authInputStyles,
});

const StyledTextFieldDesktopDark = styled(TextField, {
  name: "StyledTextField",
})({
  width: "30vw",
  ...authInputStylesDark,
});

const StyledTextFieldDesktopDarkDisabled = styled(TextField, {
  name: "StyledTextField",
})({
  pointerEvents: "none",
  width: "30vw",
  ...authInputStylesDark,
});

const StyledTextFieldDesktopErrorZipCode = styled(TextField, {
  name: "StyledTextField",
})({
  width: "30vw",
  ...authInputStyles,
  "& .MuiOutlinedInput-root": {
    ...authInputStyles["& .MuiOutlinedInput-root"],
    color: "red",
  },
});

const StyledTextFieldDesktopErrorZipCodeDark = styled(TextField, {
  name: "StyledTextField",
})({
  width: "30vw",
  ...authInputStylesDark,
  "& label.MuiInputLabel-root": {
    color: "red",
  },
  "& .MuiOutlinedInput-root": {
    ...authInputStylesDark["& .MuiOutlinedInput-root"],
    color: "red",
  },
});

const StyledTextField = styled(TextField, {
  name: "StyledTextField",
})({
  width: "60vw",
  ...authInputStyles,
});

const StyledTextFieldErrorZipCode = styled(TextField, {
  name: "StyledTextField",
})({
  width: "60vw",
  ...authInputStyles,
  "& .MuiOutlinedInput-root": {
    ...authInputStyles["& .MuiOutlinedInput-root"],
    color: "red",
  },
});

const StyledButton = styled(Button, {
  name: "StyledButton",
})({
  width: "130px",
  marginTop: "10px",
  ...authButtonStyles,
});

const StyledButtonDark = styled(Button, {
  name: "StyledButton",
})({
  height: 48,
  width: "130px",
  backgroundColor: "#0B0B0D",
  textTransform: "none",
  fontWeight: 700,
  marginTop: "10px",
  fontSize: "1.05rem",
  borderRadius: "10px",
  boxShadow: "none !important",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: "#2B2B30",
    filter: "brightness(120%)",
    border: "1px solid white",
  },
});

const StyledButtonCancel = styled(Button, {
  name: "StyledButtonCart",
})({
  width: "130px",
  marginTop: "10px",
  ...authButtonStyles,
});

const StyledButtonCancelDark = styled(Button, {
  name: "StyledButtonCart",
})({
  height: 48,
  width: "130px",
  backgroundColor: "white",
  color: "#0B0B0D",
  textTransform: "none",
  fontWeight: 700,
  marginTop: "10px",
  fontSize: "1.05rem",
  border: "1px solid #0B0B0D",
  borderRadius: "10px",
  boxShadow: "none !important",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: "#2B2B30",
    color: "white",
    border: "1px solid white",
  },
});

const StyledDeleteForeverIcon = styled(DeleteForeverIcon, {
  name: "DeleteIcon",
})({
  color: "#A4A5AA",
  height: "30px",
  margin: "0",
  "&:hover": {
    cursor: "pointer",
  },
});

const StyledInputBaseMobile = styled(InputBase, {
  name: "StyledInputBase",
})({
  width: "60vw",
  "& .MuiInputBase-input": {
    height: "24px",
    fontSize: "1rem",
    borderRadius: "10px",
    lineHeight: "24px",
    color: "#050821",
    boxSizing: "content-box",
    backgroundColor: "#fff",
    border: "1px solid #C9C9C9",
    padding: "12px 14px",
  },
});

const StyledInputBaseDesktop = styled(InputBase, {
  name: "StyledInputBase",
})({
  width: "30vw",
  "& .MuiInputBase-input": {
    height: "24px",
    fontSize: "1rem",
    borderRadius: "10px",
    lineHeight: "24px",
    color: "#050821",
    boxSizing: "content-box",
    backgroundColor: "#fff",
    border: "1px solid #C9C9C9",
    padding: "12px 14px",
  },
});

const StyledInputBaseDesktopDark = styled(InputBase, {
  name: "StyledInputBase",
})({
  width: "30vw",
  "& .MuiInputBase-input": {
    height: "24px",
    fontSize: "1rem",
    borderRadius: "10px",
    lineHeight: "24px",
    color: "white",
    boxSizing: "content-box",
    backgroundColor: "#474A56",
    padding: "12px 14px",
    border: "1px solid white",
  },
});

const StyledWorkIcon = styled(HomeWorkIcon, {
  name: "StyledWorkIcon",
})({
  color: "white",
});

const StyledBusinessIcon = styled(BusinessIcon, {
  name: "StyledBusinessIcon",
})({
  color: "white",
});

const StyledFormatListNumberedSharpIcon = styled(FormatListNumberedSharpIcon, {
  name: "StyledFormatListNumberedSharpIcon",
})({
  color: "white",
});

const StyledFlagSharpIcon = styled(FlagSharpIcon, {
  name: "StyledWorkIcon",
})({
  color: "white",
});

const StyledLocationCityIcon = styled(LocationCityIcon, {
  name: "StyledLocationCityIcon",
})({
  color: "white",
});

const StyledHolidayVillageSharpIcon = styled(HolidayVillageSharpIcon, {
  name: "StyledHolidayVillageSharpIcon",
})({
  color: "white",
});

const StyledAddBusinessIcon = styled(AddBusinessIcon, {
  name: "StyledAddBusinessIcon",
})({
  color: "white",
});

const StyledContactMailSharpIcon = styled(ContactMailSharpIcon, {
  name: "StyledContactMailSharpIcon",
})({
  color: "white",
});

const getAddressesList = (addressesState) =>
  Array.isArray(addressesState?.data) ? addressesState.data : [];

const applyAddressesResult = (result, setAddresses, setAddressesLength) => {
  const list = getAddressesList(result);
  const normalized = { ...(result || {}), data: list };
  setAddresses(normalized);
  setAddressesLength(list.length);
  return normalized;
};

export const Address = () => {
  const [addresses, setAddresses] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    shouldUnregister: false,
  });

  const [selectedAddress, setSelectedAddress] = useState({});

  const colorMode = useContext(modeContext);

  const [addAddress, setAddAddress] = useState(false);

  const { fetchGetAddresses, requestDataAddress, requestLoading, requestErrorCreate } =
    useGetAddresses();

  const { fetchCreateAddresses } = useCreateAddresses();

  const {
    fetchGetCep,
    requestDataCep,
    requestLoadingCep,
    requestErrorCep,
    setRequestDataCep,
    setRequestErrorCep,
  } = useGetCep();

  const { enqueueSnackbar } = useSnackbar();

  const [user, dispatchUserContext] = useContext(UserContext);

  const [company, dispatchCompanyContext] = useContext(CompanyContext);

  const { fetchUpdateAddresses, requestLoadingUpdate } = useUpdateAddresses();

  const { fetchDeleteAddresses, requestLoadingDelete, requestErrorDelete } =
    useDeleteAddresses();

  const AddressType =
    user?.systemRole !== 4
      ? ["Endereço Principal", "Endereço de Entrega"]
      : ["Endereço de Entrega"];

  const [addressesLength, setAddressesLength] = useState(0);

  const [updatingAddress, setUpdatingAddress] = useState(false);

  const [zipcode, setZipCode] = useState("");
  const [street, setStreet] = useState("");
  const [complement, setComplement] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [recipient, setRecipient] = useState("");
  const [addressTypeSelected, setAddressTypeSelected] = useState(null);
  const [oldZipCode, setOldZipCode] = useState("");

  const [cepLoaded, setCepLoaded] = useState({});

  const handleRequestCep = () => {
    return new Promise((resolve, reject) => {
      fetchGetCep(zipcode);
      resolve(requestDataCep.data);
    });
  };

  const handleNumber = (event) => {
    if (!requestLoading && !requestLoadingUpdate) {
      setNumber(event.target.value);
    }
  };

  const handleZipCode = (event) => {
    event.target.maxLength = 9;
    if (!requestLoading && !requestLoadingUpdate) {
      event.target.value = event.target.value.replace(/\D/g, "");
      setZipCode(event.target.value.replace(/^(\d{5})(\d)/, "$1-$2"));
    }
  };

  const handleStreet = (event) => {
    if (!requestLoading && !requestLoadingUpdate) {
      setStreet(event.target.value);
    }
  };

  const handleComplement = (event) => {
    if (!requestLoading && !requestLoadingUpdate) {
      setComplement(event.target.value);
    }
  };

  const handleState = (event) => {
    if (!requestLoading && !requestLoadingUpdate) {
      setState(event.target.value);
    }
  };

  const handleCity = (event) => {
    if (!requestLoading && !requestLoadingUpdate) {
      setCity(event.target.value);
    }
  };

  const handleDistrict = (event) => {
    if (!requestLoading && !requestLoadingUpdate) {
      setDistrict(event.target.value);
    }
  };

  const handleRecipient = (event) => {
    if (!requestLoading && !requestLoadingUpdate) {
      setRecipient(event.target.value);
    }
  };

  const [search, setSearch] = useState(false);

  const classes = useStyles();

  const isMobile = useMediaQuery("(max-width:900px)");

  const handleUpdate = async (data) => {
    data._id = selectedAddress._id;
    data.street = street;
    data.city = city;
    data.state = state;
    data.district = district;
    data.recipient = recipient;
    data.number = number;
    data.complement = complement;
    data.zipcode = zipcode;
    if (user?.systemRole === 4) {
      data.companyId = company?.company_id;
    }
    await fetchUpdateAddresses(data);
    if (user?.systemRole === 4) {
      const result = await fetchGetAddresses(company.company_id);
      applyAddressesResult(result, setAddresses, setAddressesLength);
    } else {
      const result = await fetchGetAddresses();
      applyAddressesResult(result, setAddresses, setAddressesLength);
    }
    setSelectedAddress({});
    setUpdatingAddress(false);
    setZipCode("");
    setStreet("");
    setComplement("");
    setNumber("");
    setState("");
    setCity("");
    setDistrict("");
    enqueueSnackbar("Endereço atualizado!", {
      variant: "success",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
    setRequestDataCep({});
  };

  const handleAdd = async (data) => {
    data.street = street;
    data.city = city;
    data.state = state;
    data.district = district;
    data.recipient = recipient;
    data.zipcode = zipcode;
    data.number = number;
    data.complement = complement;
    if (user?.systemRole === 4) {
      data.companyId = company?.company_id;
    }
    if (addressTypeSelected === "Endereço Principal") {
      data.type = "billing_address";
      await fetchCreateAddresses(data);
      if (user?.systemRole === 4) {
        const result = await fetchGetAddresses(company.company_id);
        applyAddressesResult(result, setAddresses, setAddressesLength);
      } else {
        const result = await fetchGetAddresses();
        applyAddressesResult(result, setAddresses, setAddressesLength);
      }
      setAddAddress(false);
      setZipCode("");
      setStreet("");
      setComplement("");
      setNumber("");
      setState("");
      setCity("");
      setDistrict("");
      enqueueSnackbar("Endereço adicionado!", {
        variant: "success",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
      setRequestDataCep({});
    } else {
      data.type = "shipping_address";
      if (user?.systemRole === 4) {
        data.companyId = company?.company_id;
      }
      const addressesList = getAddressesList(addresses);
      if (!addressesList.find((add) => add.type === "shipping_address")) {
        await fetchCreateAddresses(data);
        if (user?.systemRole === 4) {
          const result = await fetchGetAddresses(company.company_id);
          applyAddressesResult(result, setAddresses, setAddressesLength);
        } else {
          const result = await fetchGetAddresses();
          applyAddressesResult(result, setAddresses, setAddressesLength);
        }
        setAddAddress(false);
        setZipCode("");
        setStreet("");
        setComplement("");
        setNumber("");
        setState("");
        setCity("");
        setDistrict("");
        enqueueSnackbar("Endereço adicionado!", {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
        setRequestDataCep({});
      } else if (
        addressesList.find((add) => add.type === "shipping_address")
      ) {
        enqueueSnackbar(
          "Endereço de Entrega já cadastrado, atualize-o caso necessário!",
          {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          }
        );
      }
    }
  };

  const handleDelete = async (id) => {
    if (user?.systemRole === 4) {
      await fetchDeleteAddresses(id, company?.company_id);
    } else {
      await fetchDeleteAddresses(id);
    }
    if (user?.systemRole === 4) {
      const result = await fetchGetAddresses(company.company_id);
      applyAddressesResult(result, setAddresses, setAddressesLength);
    } else {
      const result = await fetchGetAddresses();
      applyAddressesResult(result, setAddresses, setAddressesLength);
    }
    enqueueSnackbar("Endereço removido!", {
      variant: "success",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
  };

  const handleCancelUpdate = () => {
    setSelectedAddress({});
    setSearch(false);
    setUpdatingAddress(false);
    setZipCode("");
    setStreet("");
    setComplement("");
    setNumber("");
    setState("");
    setCity("");
    setDistrict("");
    setRequestDataCep({});
    setRequestErrorCep(false);
    setRecipient("");
    setCepLoaded({});
    setOldZipCode("");
  };

  const handleCancelAdd = () => {
    setAddAddress(false);
    setSearch(false);
    setZipCode("");
    setStreet("");
    setComplement("");
    setNumber("");
    setState("");
    setCity("");
    setDistrict("");
    setRequestDataCep({});
    setRequestErrorCep(false);
    setRecipient("");
    setCepLoaded({});
    setOldZipCode("");
  };

  const handleAddScreen = () => {
    setSearch(true);
    setAddAddress(true);
  };

  useEffect(() => {
    const loadAddresses = async () => {
      if (addresses === null && user?.systemRole !== 4 && !requestErrorCreate) {
        const result = await fetchGetAddresses();
        if (!requestLoading) {
          applyAddressesResult(result, setAddresses, setAddressesLength);
        }
      } else if (
        addresses === null &&
        user?.systemRole === 4 &&
        company?.company_id !== undefined &&
        !requestErrorCreate
      ) {
        const result = await fetchGetAddresses(company.company_id);
        if (!requestLoading) {
          applyAddressesResult(result, setAddresses, setAddressesLength);
        }
      }
    };
    loadAddresses();

    if (
      (addAddress || updatingAddress) &&
      company?.company_id &&
      company?.companyName &&
      recipient?.length === 0
    ) {
      setRecipient(company?.companyName);
    }

    if (company?.company_id && company?.companyChanged && addAddress) {
      setAddAddress(false);
      handleCancelAdd();
    }

    if (company?.company_id && company?.companyChanged && updatingAddress) {
      setUpdatingAddress(false);
      setSelectedAddress({});
      handleCancelUpdate();
    }

    const loadAddressesChange = async () => {
      if (
        addresses !== null &&
        user?.systemRole === 4 &&
        company?.company_id !== undefined &&
        company?.companyChanged
      ) {
        const result = await fetchGetAddresses(company.company_id);
        if (!requestLoading) {
          applyAddressesResult(result, setAddresses, setAddressesLength);
        }
      }
    };
    loadAddressesChange();

    if (addressTypeSelected === null) {
      setAddressTypeSelected(AddressType[0]);
    }

    const loadSelectedAddressToUpdate = () => {
      if (
        Object.keys(selectedAddress).length !== 0 &&
        !updatingAddress &&
        !addAddress
      ) {
        setZipCode(selectedAddress.zipcode);
        setStreet(selectedAddress.street);
        setComplement(selectedAddress.complement);
        setNumber(selectedAddress.number);
        setState(selectedAddress.state);
        setCity(selectedAddress.city);
        setDistrict(selectedAddress.district);
        setRecipient(selectedAddress.recipient);
        setUpdatingAddress(true);
        setOldZipCode(selectedAddress.zipcode);
      }
    };
    loadSelectedAddressToUpdate();

    const loadCepDataUpdate = async () => {
      if (
        Object.keys(selectedAddress).length !== 0 &&
        oldZipCode !== zipcode &&
        zipcode.length > 8
      ) {
        const result = await fetchGetCep(zipcode);
        if (result?.data?.logradouro) {
          setStreet(result?.data?.logradouro);
        }
        if (result?.data?.localidade) {
          setCity(result?.data?.localidade);
        }
        if (result?.data?.bairro) {
          setDistrict(result?.data?.bairro);
        }
        if (result?.data?.uf) {
          setState(result?.data?.uf);
        }
        setOldZipCode(zipcode);
      }
    };
    loadCepDataUpdate();

    const loadCepDataAdd = async () => {
      if (addAddress && oldZipCode !== zipcode && zipcode.length > 8) {
        const result = await fetchGetCep(zipcode);
        if (result?.data?.logradouro) {
          setStreet(result?.data?.logradouro);
        }
        if (result?.data?.localidade) {
          setCity(result?.data?.localidade);
        }
        if (result?.data?.bairro) {
          setDistrict(result?.data?.bairro);
        }
        if (result?.data?.uf) {
          setState(result?.data?.uf);
        }
        setOldZipCode(zipcode);
      }
    };
    loadCepDataAdd();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    requestDataAddress,
    addresses,
    oldZipCode,
    requestErrorCep,
    selectedAddress,
    zipcode,
    street,
    complement,
    number,
    state,
    city,
    district,
    updatingAddress,
    requestLoading,
    requestLoadingUpdate,
    requestLoadingDelete,
    addressesLength,
    requestDataCep,
    requestLoadingCep,
    search,
    requestErrorCreate,
    addAddress,
    requestErrorDelete,
    user,
    company,
  ]);

  return (
    <div
      className={
        isMobile && Object.keys(selectedAddress).length === 0 && !addAddress
          ? classes.root
          : (isMobile && Object.keys(selectedAddress).length !== 0) ||
            (isMobile && addAddress)
          ? classes.rootEdit
          : ((!isMobile && Object.keys(selectedAddress).length !== 0) ||
              (!isMobile && addAddress)) &&
            colorMode !== "dark"
          ? classes.rootDesktopEdit
          : (!isMobile && Object.keys(selectedAddress).length !== 0) ||
            (!isMobile && addAddress && colorMode === "dark")
          ? classes.rootDesktopEditDark
          : addresses === null
          ? classes.rootLoading
          : classes.rootDesktop
      }
    >
      {addresses !== null &&
        Object.keys(selectedAddress).length === 0 &&
        !addAddress && (
          <div className={classes.sessionTitleContainer}>
            <h2 className={classes.sessionTitle}>Endereços</h2>
            {colorMode !== "dark" || isMobile ? (
              <StyledAddCircleSharpIcon onClick={() => handleAddScreen()} />
            ) : (
              <StyledAddCircleSharpIconDark onClick={() => handleAddScreen()} />
            )}
          </div>
        )}

      {addresses !== null &&
      Object.keys(selectedAddress).length === 0 &&
      !addAddress ? (
        getAddressesList(addresses).map(
          (address, index) =>
            address?.zipcode !== undefined && (
              <div className={classes.iconAndAddressContainer} key={address._id || index}>
                <div className={classes.addressContainer}>
                  <h3 className={classes.addressTitle}>
                    {address.type === "shipping_address"
                      ? "Endereço de Entrega"
                      : "Endereço Principal"}
                  </h3>
                  <p
                    className={classes.addressInfo}
                  >{`${address.street}, ${address.number}`}</p>
                  <p
                    className={classes.addressInfo}
                  >{`${address.district} - ${address.state}`}</p>
                  <p
                    className={classes.addressInfo}
                  >{`CEP ${address.zipcode}`}</p>
                </div>
                <div className={classes.editAndDeleteIconContainer}>
                  {colorMode !== "dark" || isMobile ? (
                    <StyledEditIcon
                      onClick={() =>
                        setSelectedAddress(getAddressesList(addresses)[index])
                      }
                    />
                  ) : (
                    <StyledEditIconDark
                      onClick={() =>
                        setSelectedAddress(getAddressesList(addresses)[index])
                      }
                    />
                  )}
                  {user?.systemRole !== 4 && (
                    <StyledDeleteForeverIcon
                      onClick={() => handleDelete(address._id)}
                    />
                  )}
                </div>
              </div>
            )
        )
      ) : (
        <>
          <div>
            {isMobile ? (
              <form
                className={classes.inputsAndButtonsContainer}
                onSubmit={
                  Object.keys(selectedAddress).length !== 0
                    ? handleSubmit(handleUpdate)
                    : handleSubmit(handleAdd)
                }
              >
                <div className={classes.inputsContainer}>
                  <div className={classes.IconAndInputContainer}>
                    <ContactMailSharpIcon />(
                    <StyledTextField
                      required
                      id="zipcode-input"
                      label="CEP"
                      type="text"
                      autoComplete="off"
                      {...register("zipcode")}
                      value={zipcode}
                      onChange={(e) => handleZipCode(e)}
                    />
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    <HomeWorkIcon />
                    <StyledTextField
                      required
                      id="street-input"
                      label="Rua"
                      type="text"
                      autoComplete="off"
                      {...register("street")}
                      value={street}
                      onChange={(e) => handleStreet(e)}
                    />
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    <FormatListNumberedSharpIcon />
                    <StyledTextField
                      required
                      id="number-input"
                      label="Número"
                      type="text"
                      autoComplete="off"
                      {...register("number")}
                      value={number}
                      onChange={(e) => handleNumber(e)}
                    />
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    <BusinessIcon />
                    <StyledTextField
                      id="complement-input"
                      label="Complemento"
                      type="text"
                      autoComplete="off"
                      {...register("complement")}
                      value={complement}
                      onChange={(e) => handleComplement(e)}
                    />
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    <FlagSharpIcon />
                    <StyledTextField
                      required
                      id="state-input"
                      label="Estado"
                      type="text"
                      autoComplete="off"
                      {...register("state")}
                      value={state}
                      onChange={(e) => handleState(e)}
                    />
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    <LocationCityIcon />
                    <StyledTextField
                      required
                      id="city-input"
                      label="Cidade"
                      type="text"
                      autoComplete="off"
                      {...register("city")}
                      value={city}
                      onChange={(e) => handleCity(e)}
                    />
                  </div>

                  <div className={classes.IconAndInputContainer}>
                    <HolidayVillageSharpIcon />
                    <StyledTextField
                      required
                      id="district-input"
                      label="Bairro"
                      type="text"
                      autoComplete="off"
                      {...register("district")}
                      value={district}
                      onChange={(e) => handleDistrict(e)}
                    />
                  </div>
                  <div className={classes.selectContainer}>
                    {Object.keys(selectedAddress).length === 0 && (
                      <>
                        {" "}
                        <AddBusinessIcon />{" "}
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={addressTypeSelected}
                          label="Tipo"
                          input={<StyledInputBaseMobile />}
                          onChange={(e) =>
                            setAddressTypeSelected(e.target.value)
                          }
                          className={classes.select}
                        >
                          {AddressType.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </>
                    )}
                  </div>
                </div>
                <div
                  className={
                    isMobile
                      ? classes.buttonsContainerMobile
                      : classes.buttonsContainer
                  }
                >
                  {Object.keys(selectedAddress).length !== 0 ? (
                    <StyledButton type="submit" variant="contained">
                      Salvar
                    </StyledButton>
                  ) : (
                    <StyledButton type="submit" variant="contained">
                      Salvar
                    </StyledButton>
                  )}
                  {Object.keys(selectedAddress).length !== 0 ? (
                    <StyledButtonCancel
                      onClick={() => handleCancelUpdate()}
                      variant="contained"
                    >
                      Cancelar
                    </StyledButtonCancel>
                  ) : (
                    <StyledButtonCancel
                      onClick={() => handleCancelAdd()}
                      variant="contained"
                    >
                      Cancelar
                    </StyledButtonCancel>
                  )}
                </div>
              </form>
            ) : (
              <form
                className={classes.inputsAndButtonsContainer}
                onSubmit={
                  Object.keys(selectedAddress).length !== 0
                    ? handleSubmit(handleUpdate)
                    : handleSubmit(handleAdd)
                }
              >
                <div className={classes.inputsContainer}>
                  <div className={classes.IconAndInputContainer}>
                    {colorMode !== "dark" ? (
                      <ContactMailSharpIcon />
                    ) : (
                      <StyledContactMailSharpIcon />
                    )}
                    <StyledTextFieldDesktop
                      required
                      id="zipcode-input"
                      label="CEP"
                      type="text"
                      autoComplete="off"
                      {...register("zipcode")}
                      value={zipcode}
                      onChange={(e) => handleZipCode(e)}
                    />
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    {colorMode !== "dark" ? (
                      <HomeWorkIcon />
                    ) : (
                      <StyledWorkIcon />
                    )}
                    {colorMode !== "dark" ? (
                      <StyledTextFieldDesktop
                        required
                        id="street-input"
                        label="Rua"
                        type="text"
                        autoComplete="off"
                        {...register("street")}
                        value={street}
                        onChange={(e) => handleStreet(e)}
                      />
                    ) : (
                      <StyledTextFieldDesktopDarkDisabled
                        required
                        id="street-input"
                        label="Rua"
                        type="text"
                        autoComplete="off"
                        {...register("street")}
                        value={street}
                        onChange={(e) => handleStreet(e)}
                      />
                    )}
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    {colorMode !== "dark" ? (
                      <FormatListNumberedSharpIcon />
                    ) : (
                      <StyledFormatListNumberedSharpIcon />
                    )}
                    {colorMode !== "dark" ? (
                      <StyledTextFieldDesktop
                        required
                        id="number-input"
                        label="Número"
                        type="text"
                        autoComplete="off"
                        {...register("number")}
                        value={number}
                        onChange={(e) => handleNumber(e)}
                      />
                    ) : (
                      <StyledTextFieldDesktopDark
                        required
                        id="number-input"
                        label="Número"
                        type="text"
                        autoComplete="off"
                        {...register("number")}
                        value={number}
                        onChange={(e) => handleNumber(e)}
                      />
                    )}
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    {colorMode !== "dark" ? (
                      <BusinessIcon />
                    ) : (
                      <StyledBusinessIcon />
                    )}
                    {colorMode !== "dark" ? (
                      <StyledTextFieldDesktop
                        id="complement-input"
                        label="Complemento"
                        type="text"
                        autoComplete="off"
                        {...register("complement")}
                        value={complement}
                        onChange={(e) => handleComplement(e)}
                      />
                    ) : (
                      <StyledTextFieldDesktopDark
                        id="complement-input"
                        label="Complemento"
                        type="text"
                        autoComplete="off"
                        {...register("complement")}
                        value={complement}
                        onChange={(e) => handleComplement(e)}
                      />
                    )}
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    {colorMode !== "dark" ? (
                      <FlagSharpIcon />
                    ) : (
                      <StyledFlagSharpIcon />
                    )}
                    {colorMode !== "dark" ? (
                      <StyledTextFieldDesktop
                        required
                        id="state-input"
                        label="Estado"
                        type="text"
                        autoComplete="off"
                        {...register("state")}
                        value={state}
                        onChange={(e) => handleState(e)}
                      />
                    ) : (
                      <StyledTextFieldDesktopDarkDisabled
                        required
                        id="state-input"
                        label="Estado"
                        type="text"
                        autoComplete="off"
                        {...register("state")}
                        value={state}
                        onChange={(e) => handleState(e)}
                      />
                    )}
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    {colorMode !== "dark" ? (
                      <LocationCityIcon />
                    ) : (
                      <StyledLocationCityIcon />
                    )}
                    {colorMode !== "dark" ? (
                      <StyledTextFieldDesktop
                        required
                        id="city-input"
                        label="Cidade"
                        type="text"
                        autoComplete="off"
                        {...register("city")}
                        value={city}
                        onChange={(e) => handleCity(e)}
                      />
                    ) : (
                      <StyledTextFieldDesktopDarkDisabled
                        required
                        id="city-input"
                        label="Cidade"
                        type="text"
                        autoComplete="off"
                        {...register("city")}
                        value={city}
                        onChange={(e) => handleCity(e)}
                      />
                    )}
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    {colorMode !== "dark" ? (
                      <HolidayVillageSharpIcon />
                    ) : (
                      <StyledHolidayVillageSharpIcon />
                    )}
                    {colorMode !== "dark" ? (
                      <StyledTextFieldDesktop
                        required
                        id="district-input"
                        label="Bairro"
                        type="text"
                        autoComplete="off"
                        {...register("district")}
                        value={district}
                        onChange={(e) => handleDistrict(e)}
                      />
                    ) : (
                      <StyledTextFieldDesktopDarkDisabled
                        required
                        id="district-input"
                        label="Bairro"
                        type="text"
                        autoComplete="off"
                        {...register("district")}
                        value={district}
                        onChange={(e) => handleDistrict(e)}
                      />
                    )}
                  </div>
                  <div className={classes.IconAndInputContainer}>
                    <FaceIcon />
                    <StyledTextFieldDesktop
                      required
                      id="recipient-input"
                      label="Destinatário"
                      type="text"
                      autoComplete="off"
                      {...register("recipient")}
                      value={recipient}
                      onChange={(e) => handleRecipient(e)}
                    />
                  </div>
                  <div className={classes.selectContainer}>
                    {Object.keys(selectedAddress).length === 0 && (
                      <>
                        {colorMode !== "dark" ? (
                          <AddBusinessIcon />
                        ) : (
                          <StyledAddBusinessIcon />
                        )}{" "}
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={addressTypeSelected}
                          label="Tipo"
                          input={
                            colorMode !== "dark" ? (
                              <StyledInputBaseDesktop />
                            ) : (
                              <StyledInputBaseDesktopDark />
                            )
                          }
                          onChange={(e) =>
                            setAddressTypeSelected(e.target.value)
                          }
                          className={classes.select}
                        >
                          {AddressType.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </>
                    )}
                  </div>
                </div>
                <div
                  className={
                    isMobile
                      ? classes.buttonsContainerMobile
                      : classes.buttonsContainer
                  }
                >
                  {Object.keys(selectedAddress).length !== 0 &&
                  colorMode !== "dark" ? (
                    <StyledButton type="submit" variant="contained">
                      Salvar
                    </StyledButton>
                  ) : colorMode !== "dark" ? (
                    <StyledButton type="submit" variant="contained">
                      Salvar
                    </StyledButton>
                  ) : (
                    <StyledButtonDark type="submit" variant="contained">
                      Salvar
                    </StyledButtonDark>
                  )}
                  {Object.keys(selectedAddress).length !== 0 &&
                  colorMode !== "dark" ? (
                    <StyledButtonCancel
                      onClick={() => handleCancelUpdate()}
                      variant="contained"
                    >
                      Cancelar
                    </StyledButtonCancel>
                  ) : Object.keys(selectedAddress).length !== 0 &&
                    colorMode === "dark" ? (
                    <StyledButtonCancelDark
                      onClick={() => handleCancelUpdate()}
                      variant="contained"
                    >
                      Cancelar
                    </StyledButtonCancelDark>
                  ) : colorMode !== "dark" ? (
                    <StyledButtonCancel
                      onClick={() => handleCancelAdd()}
                      variant="contained"
                    >
                      Cancelar
                    </StyledButtonCancel>
                  ) : (
                    <StyledButtonCancelDark
                      onClick={() => handleCancelAdd()}
                      variant="contained"
                    >
                      Cancelar
                    </StyledButtonCancelDark>
                  )}
                </div>
              </form>
            )}
          </div>
        </>
      )}
    </div>
  );
};
